import {CaseSortFilter} from "./CaseSortFilter";

export class Sort {

  property?: string;
  order?: 'ASC'|'DESC';
  caseSortFilters?: Array<CaseSortFilter> = [];
}
